import { render, staticRenderFns } from "./OzBaseSnackbar.vue?vue&type=template&id=a93371da&"
import script from "./OzBaseSnackbar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzBaseSnackbar.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports